/**
 * MobileManager.js
 * Mobil cihaz tespiti ve performans optimizasyonlarını yönetir.
 */
const MobileManager = {
    isMobile: false,

    init: function () {
        this.checkDevice();
        this.applyOptimizations();
        this.logStatus();
    },

    /**
     * Cihaz tipini tespit eder.
     */
    checkDevice: function () {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

        // window.utils üzerinden de erişilebilir olsun (geriye dönük uyumluluk için)
        if (window.utils) {
            window.utils.isMobile = () => this.isMobile;
        }
    },

    /**
     * Mobil cihazlar için optimizasyonları uygular.
     */
    applyOptimizations: function () {
        if (this.isMobile) {
            document.body.classList.add('is-mobile');

            // Ağır animasyonları veya efektleri kapat
            this.disableHeavyEffects();
        } else {
            document.body.classList.add('is-desktop');
            document.body.classList.remove('is-mobile');
        }
    },

    disableHeavyEffects: function () {
        // Örnek: Ağır parçacık efektlerini kapatma veya azaltma
        const heavyElements = document.querySelectorAll('.orb-3, .complex-bg-anim');
        heavyElements.forEach(el => {
            el.style.display = 'none';
        });

        // CSS değişkenleri ile animasyon hızlarını düşürme veya kapatma
        document.documentElement.style.setProperty('--animation-speed', '0s');
    },

    logStatus: function () {
        console.log(`MobileManager: Device detected as ${this.isMobile ? 'MOBILE' : 'DESKTOP'}`);
    }
};

window.MobileManager = MobileManager;
export default MobileManager;
